import React from 'react';
import { Hero } from '../components/Hero';
import { ThreePillars } from '../components/ThreePillars';
import { ExplainerVideo } from '../components/ExplainerVideo';
import { HowItWorks } from '../components/HowItWorks';
import { PartnerDashboards } from '../components/PartnerDashboards';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { motion, useScroll, useSpring } from 'framer-motion';
export function LandingPage() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  return <div className="min-h-screen bg-white font-sans text-brand-dark selection:bg-brand-primary/20 selection:text-brand-primary" data-id="element-714">
      {/* Progress Bar */}
      <motion.div className="fixed top-0 left-0 right-0 h-1 bg-brand-primary origin-left z-50" style={{
      scaleX
    }} data-id="element-715" />

      <Navigation data-id="element-716" />

      <main data-id="element-717">
        <Hero data-id="element-718" />
        <ThreePillars data-id="element-719" />
        <ExplainerVideo data-id="element-720" />
        <HowItWorks data-id="element-721" />
        <PartnerDashboards data-id="element-722" />
      </main>

      <Footer data-id="element-723" />
    </div>;
}